import React from 'react';
import {Autocomplete, TextField} from "@mui/material";

export const TypeOption = {
  'Local Business': 'localBusiness',
  'Local Event': 'localEvent',
  'Local Non-Profit': 'localNonProfit',
};

interface ContentTypeProps {
  setType: (value: keyof typeof TypeOption) => void,
  value: any
}

export const ContentType = ({setType, value}: ContentTypeProps) => {

  const options = Object.entries(TypeOption).map(([key, val]) => ({label: key, id: val}));

  const onChange = (event: React.SyntheticEvent<Element, Event>, value: any) => {
    setType(value.label)
  };

  return (
    <div>
      <Autocomplete
        sx={{paddingBottom: 2}}
        id="user-input-content-type"
        disableClearable
        options={options}
        defaultValue={options[0]}
        value={value}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        onChange={(event: React.SyntheticEvent<Element, Event>, value: any) => onChange(event, value)}
        renderInput={(params) => <TextField {...params} label="Type" required/>}
      />
    </div>
  );
};
